module.exports = __webpack_public_path__ + "img/Film_5in1_Mens_Shot.88c9d50e.jpg";